import { ArrowDownIcon, ArrowUpIcon } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { useLocation, useNavigate } from "react-router-dom";

import { LuChevronsUpDown } from "react-icons/lu";
import { cn } from "@/utils/cn";
import { useMemo } from "react";

const DataTableColumnHeader = ({ column, title, className }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get the current sort state from query params
  const currentSort = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("sort") || null;
  }, [location.search]);

  const sortingColumn = column.columnDef.accessorKey || column.id;
  const isSorted = useMemo(() => {
    if (currentSort === sortingColumn) return "asc";
    if (currentSort === `-${sortingColumn}`) return "desc";
    return null;
  }, [currentSort, sortingColumn]);

  if (!column.getCanSort()) {
    return (
      <div
        className={cn(
          className,
          "px-2 w-auto text-sm h-12 flex items-center justify-center font-normal text-black"
        )}
      >
        {title}
      </div>
    );
  }

  const handleSort = (sort) => {
    const params = new URLSearchParams(location.search);

    if (sort === "asc") {
      params.set("sort", `${sortingColumn}`);
    } else if (sort === "desc") {
      params.set("sort", `-${sortingColumn}`);
    } else {
      params.delete("sort");
    }

    navigate({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  return (
    <div className={cn("flex space-x-2 h-full w-full", className)}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="h-full px-2 active:border-none outline-none flex items-center data-[state=open]:bg-accent w-full justify-between">
            <span>{title}</span>
            <span>
              {isSorted === "desc" ? (
                <ArrowDownIcon className="ml-2 h-4 w-4" />
              ) : isSorted === "asc" ? (
                <ArrowUpIcon className="ml-2 h-4 w-4" />
              ) : (
                <LuChevronsUpDown className="ml-2 h-4 w-4" />
              )}
            </span>
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => handleSort("asc")}
          >
            <ArrowUpIcon className="mr-2 h-3.5 w-3.5 text-muted-foreground/70" />
            Asc
          </DropdownMenuItem>
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => handleSort("desc")}
          >
            <ArrowDownIcon className="mr-2 h-3.5 w-3.5 text-muted-foreground/70" />
            Desc
          </DropdownMenuItem>
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => handleSort()}
          >
            <LuChevronsUpDown className="mr-2 h-3.5 w-3.5 text-muted-foreground/70" />
            Reset
          </DropdownMenuItem>
          {/* <DropdownMenuSeparator />
          <DropdownMenuItem className="cursor-pointer">
            <EyeIcon className="mr-2 h-3.5 w-3.5 text-muted-foreground/70" />
            Hide
          </DropdownMenuItem> */}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default DataTableColumnHeader;
